import { useRegion } from "../../../customhooks/useRegion";
import { useEffect, useState } from "react";
import Joyride from 'react-joyride';
import { Template1Steps } from "../../../data/joyrideSteps.js";
import { useAuth } from "../../Login/AuthContext.js";
import { useUsageLimit } from "../../../customhooks/useUsageLimit.js";
import { validateInputs, buildExamRequest, initializeJoyride } from "./aiPromptHelper/aiPromptHelper.js";
import SelectedSubjects from "../../Subjects/SubjectChips/SubjectChips.jsx";
import { CircularProgress } from "@mui/material";
import RegionSwitch from "./regionSwitch/regionSwitch.jsx";
import Yeargroupbuttons from "../../YearGroup/Yeargroup";
import Difficlutybuttons from '../../Difficulty/difficulty';
import SubjectsLibrary from "../../Subjects/Subject";

import addIcon from '../../../assets/add-circle.svg'
import glitterIcon from '../../../assets/glitter.svg'
import listIcon from '../../../assets/list.svg'
import './aiprompt.css';


export default function ExamRevision({ generateContentAndPdf, loading }) {



  const [selectedSubjects, setSelectedSubjects] = useState([]);
  const [prompt, setPrompt] = useState(null);
  const [selectedYear, setSelectedYear] = useState(null);
  const [open, setOpen] = useState(false);
  const [textbox2, setTextbox2] = useState(null);
  const [region, setRegion] = useRegion();
  const [difficulty, setDifficulty] = useState(null);
  const [run, setRun] = useState(false);
  const [errors, setErrors] = useState({
    nameError: '',
    countError: '',
    yearError: '',
    difficultyError: '',
    subjectError: '',
  });

  const { isAuthenticated, aiAllowance } = useAuth();
  const { remainingUses, isDisabled, incrementUsage } = useUsageLimit("globalUsage", 5, undefined, isAuthenticated);

  useEffect(() => initializeJoyride(setRun), []);

  useEffect(() => {
    setPrompt(buildExamRequest(textbox2, difficulty, selectedYear, selectedSubjects, region));
  }, [textbox2, difficulty, selectedYear, selectedSubjects, region]);


  const submitHandler = (e) => {
    e.preventDefault();
    if (aiAllowance?.usage?.remaining === 0) return;

    // Validate inputs only if authenticated or increment usage if not
    if (validateInputs({ textbox2, selectedYear, difficulty, selectedSubjects }, setErrors)) {
      if (!isAuthenticated) incrementUsage();

      // Check if user is authenticated
      if (!isAuthenticated && isDisabled) {
        alert('You have reached the maximum number of uses. Please sign up for free credits! 👉🏻');
        return;
      }



      // Proceed with generating content and PDF
      generateContentAndPdf(prompt);
    }
  };

  const handleSelection = (setter, field, value, val) => {
    setter(value);
    if (value) {
      setErrors((prevErrors) => ({ ...prevErrors, [field]: '' }));
    }
  };


  const handleRemoveSubject = (subjectToRemove) => {
    setSelectedSubjects((prev) =>
      prev.filter((subject) => subject !== subjectToRemove)
    );
  };

  return (
    <div className="exam-style-revision">

      <Joyride
        steps={Template1Steps}
        run={run}
        continuous
        scrollToFirstStep
        showSkipButton
        styles={{ options: { zIndex: 10000 } }}
      />

      <label htmlFor="questionCount" className="form-label">
        <img src={listIcon} alt="info" style={{ width: '16px', height: '16px', }} />
        Number of Questions

      </label>

      <div className="basic_details_count">
        {[10, 20, 30].map((val) => (
          <button
            key={val}
            onClick={() => handleSelection(setTextbox2, 'countError', val)}
            className={`count-button ${textbox2 === val ? 'active' : ''}`}
            type="button"
          >
            {val}
          </button>
        ))}
      </div>

      {errors.countError && <p className="error">{errors.countError}</p>}

      {/* Region Switch */}
      <div >
        <RegionSwitch region={region} setRegion={setRegion} />
      </div>


      <Yeargroupbuttons selectedYeargroup={selectedYear} region={region} onClick={(year) => handleSelection(setSelectedYear, 'yearError', year)} />
      {errors.yearError && <p className="error">{errors.yearError}</p>}


      <Difficlutybuttons selectedDifficulty={difficulty} onClick={(diff) => handleSelection(setDifficulty, 'difficultyError', diff)} />

      {errors.difficultyError && <p className="error">{errors.difficultyError}</p>}

      <button
        className="add-lessons-button"
        onClick={() => setOpen(true)}
      >
        <img
          src={addIcon}
          alt="addIcon"
          style={{ width: '16px', height: '16px', marginRight: '5px' }}
        />
        Pick Lessons
      </button>
      <SubjectsLibrary
        open={open}
        selectedSubjects={selectedSubjects}
        onSelect={setSelectedSubjects}
        onClose={() => setOpen(false)}
        region={region}
      />

      {errors.subjectError && <p className="error">{errors.subjectError}</p>}

      <SelectedSubjects
        selectedSubjects={selectedSubjects}
        onRemove={handleRemoveSubject}
        onClearAll={() => setSelectedSubjects([])}
      />

      <button
        className="generate-button"
        data-gtm-event="track-click"
        gtm-data-label="generated-questions-revision-temp"
        onClick={submitHandler}
        disabled={loading || aiAllowance?.usage?.remaining === 0}
      >
        {loading ? (
          <CircularProgress
            size={18}
            color="inherit"
            style={{ marginRight: "8px" }}
          />
        ) : (
          <img
            src={glitterIcon}
            alt="addIcon"
            style={{ width: "16px", height: "16px", marginRight: "5px" }}
          />
        )}
        {loading
          ? "Generating..."
          : isAuthenticated
            ? "Generate Questions"
            : `Generate (${remainingUses} remaining)`}
      </button>
    </div>

  );
}
